import React, { useState } from "react";
import { DayPicker, Modifiers } from "react-day-picker";
import { format, getYear, isWithinInterval } from "date-fns";
import { Input, Popover, PopoverBody } from "reactstrap";
import "react-day-picker/dist/style.css";

interface Props {
  date: Date;
  onDateChange: (date: Date) => void;
  start: Date;
  end: Date;
}

export default function DayPickerInput(props: Props) {
  const { date, onDateChange, start, end } = props;
  const [isOpen, setIsOpen] = useState(false);

  const togglePopover = () => setIsOpen(!isOpen);

  const handleDayClick = (
    _day: Date | undefined,
    selected: Date,
    disabled: Modifiers,
  ) => {
    if (disabled.disabled === true) return;
    onDateChange(selected);
    setIsOpen(false);
  };

  // Style indicator based on if date is valid
  const isDateInRange = isWithinInterval(date, { start, end });
  const dateStatus = isDateInRange ? "valid" : "invalid";

  return (
    <div className="date-picker-wrapper">
      <Input
        value={format(date, "yyyy-MM-dd")}
        readOnly
        id="Popover1"
        className={`date-input ${dateStatus}`}
        onClick={togglePopover}
      />
      <div className="date-icon"></div>

      <Popover
        className="day-picker-popover"
        target="Popover1"
        isOpen={isOpen}
        toggle={togglePopover}
        trigger="legacy"
        placement="bottom"
      >
        <PopoverBody className="day-picker-body">
          <DayPicker
            mode="single"
            captionLayout="dropdown"
            fromYear={getYear(start)}
            toYear={getYear(end)}
            selected={date}
            onSelect={handleDayClick}
            disabled={{
              before: start,
              after: end,
            }}
            modifiersClassNames={{
              selected: "day-selected",
              today: "day-today",
              disabled: "day-disabled",
            }}
            styles={{
              caption: {
                display: "flex",
                justifyContent: "space-between",
                padding: "0.5rem",
              },
              caption_label: { fontWeight: 600 },
              nav: { display: "flex", gap: "0.5rem" },
              table: { margin: "0.5rem 0" },
              day: { margin: "0.2rem" },
              head_cell: {
                padding: "0.5rem",
                color: "#64748B",
                fontWeight: 500,
              },
            }}
          />

          <div className="date-range-info">
            <span>Available Range:</span>
            <div className="date-range">
              <span>{format(start, "MMM d, yyyy")}</span>
              <span className="date-separator">-</span>
              <span>{format(end, "MMM d, yyyy")}</span>
            </div>
          </div>
        </PopoverBody>
      </Popover>
    </div>
  );
}
